import { Avatar, ModalDialog, type AvatarStackPerson } from '@amelio/ui-library';
import { useTranslation } from 'react-i18next';

interface ContributorsDialogProps {
    isOpen: boolean;
    onClose: () => void;
    /** Already ordered and named for the reader. */
    contributors: AvatarStackPerson[];
}

/** Every contributor of an objective, one per line, in the order of the stack that opened it. */
export default function ContributorsDialog({
    isOpen,
    onClose,
    contributors,
}: ContributorsDialogProps) {
    const { t } = useTranslation();

    return (
        <ModalDialog
            isOpen={isOpen}
            onClose={onClose}
            title={t('objectives.contributors.dialogTitle', { count: contributors.length })}
            size={'sm'}
            closeAriaLabel={t('common.close')}
            dataTestId={'objective-contributors-dialog'}
        >
            <ul className={'flex flex-col gap-3'}>
                {contributors.map((contributor) => (
                    <li
                        key={contributor.id}
                        className={'flex items-center gap-3'}
                    >
                        {/* The name is written beside it: the picture adds nothing to read aloud. */}
                        <span aria-hidden>
                            <Avatar
                                src={contributor.src}
                                alt={contributor.name}
                                initials={contributor.initials}
                                size={'3xs'}
                            />
                        </span>

                        <span className={'text-navy text-sm font-medium'}>{contributor.name}</span>
                    </li>
                ))}
            </ul>
        </ModalDialog>
    );
}
